import styled from 'styled-components';
import { Button as MuiButton } from '@mui/material';

export const Button = styled(MuiButton)`
  color:  ${({ theme }) => theme.white} !important;
`;


